export default __webpack_public_path__ + "static/media/D-Standard.f525a88d.png";